import React from "react";
import LanguageSelectButton from "../LanguageSelectButton";

const LanguageSelector = (props) => {
  return (
    <React.Fragment>
      <LanguageSelectButton id="gb" className={props.className} lang="gb" />
      <LanguageSelectButton id="pl" className={props.className} lang="pl" />
    </React.Fragment>
  );
};

export default LanguageSelector;
